import { Logout } from '@mui/icons-material';
import { Stack } from '@mui/material';
import HamburgerMenuLoggedUser from './HamburgerMenuLoggedUser';
import { useIsAuthenticated } from '@azure/msal-react';
import { publicNavItems } from '../../../../lib/constants/nav-menu-data';
import HamburgerMenuItem from '../HamburgerMenuItem';
import { NavItemProps } from '../NavItem';

const HamburgerAccountItem = ({ onClick }: Pick<NavItemProps, 'onClick'>) => {
    const isAuthenticated = useIsAuthenticated();
    return (
        <>
            {isAuthenticated ? (
                <Stack marginTop={3} direction="row" gap={1}>
                    <Logout sx={{ color: 'white' }} />
                    <HamburgerMenuLoggedUser sx={{ color: 'white' }} />
                </Stack>
            ) : (
                <>
                    {publicNavItems.map((item) => (
                        <HamburgerMenuItem key={item.label} onClick={onClick} item={item} />
                    ))}
                </>
            )}
        </>
    );
};

export default HamburgerAccountItem;
